export const resources = {
  resourcesFolderInfoText: 'Файл(ов)',
  resourcesItemInfoLastUpdText: 'Обновлено',
  resourcesItemInfoUploadedText: 'Загружено',
  resourcesSearchInputText: 'Поиск',
  resourcesUserActionSheetOptionTitle: 'Скопировать ссылку',
  resourcesActionCopiedAlertText: 'Ссылка скопирована!',
  resourcesOwnersCurtainEditOptionText: 'Изменить название',
  resourcesOwnersCurtainDeleteOptionText: 'Удалить',
  resourcesOwnerCurtainHideOptionText: 'Скрыть (Inactive)',
  resourcesEditPopupTitle: 'Изменить название',
  resourcesEditPopupResetButtonTitle: 'Сбросить',
  resourcesEditPopupApplyButtonTitle: 'Применить',
  resourcesItemEditedAlertText: 'Файл успешно обновлён!',
  resourcesHidePopupTitle: 'Скрыть',
  resourcesHidePopupText: 'Скрыть файл?',
  resourcesHidePopupCancelButtonTitle: 'Отменить',
  resourcesHidePopupConfirmButtonTitle: 'Подтвердить',
  resourcesDeletePopupTitle: 'Удаление',
  resourcesDeletePopupText: 'Удалить файл?',
  resourcesDeletePopupCancelButtonTitle: 'Отменить',
  resourcesDeletePopupConfirmButtonTitle: 'Подтвердить',
  resourcesItemDeletedAlertText: 'Файл успешно удалён!',
  resourceDetailsLinkText: 'Это внешняя URL-адреса, она откроется в новом окне. Открыть?',
  resourceDetailsLinkOpenButtonTitle: 'Открыть',
  resourceDetailsLinkOpenAgainButtonTitle: 'Открыть снова',
  resourceDetailsLinkCopyURLButtonTitle: 'Скопировать ссылку',
  resourceDetailsLinkCopiedURLAlertText: 'Ссылка скопирована!',
  resurceDetailsLinkCurtainOptionCopyText: 'Скопировать ссылку',
  resourceDetailsFileInfoLastUpdText: 'Обновлено',
  resourceDetailsFileInfoUploadText: 'Загружено',
  resourceDetailsFileSaveButtonTitle: 'Открыть',
  resourceDetailsFileCopyButtonTitle: 'Скопировать ссылку',
  resourcesOwnersCurtainCopyOptionText: 'Скопировать ссылку',
  resourceDetailsFileLoadingText: 'Загрузка...',
  resourceDetailsImageCurtainCopyOptionText: 'Скопировать ссылку',
  resourceDetailsImageCurtainDownloadOptionText: 'Скачать',
  resourceFolder: 'Папка',
  resourceAdded: 'Добавлено'
}
